import { Link, Outlet } from 'react-router-dom';

import { routes } from '@/config/routes';

import { AuthBrandPanel } from './AuthBrandPanel';
import { AuthCard } from './AuthCard';

export function AuthLayout() {
  return (
    <div className="auth-shell">
      <a className="skip-link" href="#auth-main">
        Skip to authentication form
      </a>
      <div className="auth-shell__topbar">
        <Link className="wordmark" to={routes.home} aria-label="Emazy storefront home">
          <span className="wordmark__mark" aria-hidden="true">
            E
          </span>
          <span>Emazy</span>
        </Link>
        <Link className="text-link" to={routes.home}>
          <i className="pi pi-arrow-left" aria-hidden="true" /> Back to storefront
        </Link>
      </div>
      <div className="auth-shell__content">
        <AuthBrandPanel />
        <main className="auth-main" id="auth-main" tabIndex={-1}>
          <AuthCard>
            <Outlet />
          </AuthCard>
        </main>
      </div>
    </div>
  );
}
